export { default as Hero } from './Hero'
export { default as classes } from './Hero.module.scss'
export { default as InfoDialog } from './info/InfoDialog'
export { default as OpenTimeItem } from './info/OpenTimeItem'
